import { SITE_URL, structuredData } from "./config.mjs";

function setMeta(attribute, key, content) {
  let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function applySeo(meta) {
  document.title = meta.title;
  setMeta("name", "description", meta.description);
  setMeta("name", "robots", meta.robots);
  // A single owner prevents a previous route's canonical/schema from surviving navigation.
  document.head.querySelectorAll('link[rel="canonical"]').forEach((tag) => tag.remove());
  if (meta.canonical) {
    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = meta.canonical;
    document.head.appendChild(canonical);
  }
  setMeta("property", "og:type", "website");
  setMeta("property", "og:title", meta.title);
  setMeta("property", "og:description", meta.description);
  setMeta("property", "og:url", meta.canonical || `${SITE_URL}/`);
  setMeta("property", "og:image", `${SITE_URL}/icon-logo.png`);
  setMeta("name", "twitter:title", meta.title);
  setMeta("name", "twitter:description", meta.description);
  setMeta("name", "twitter:url", meta.canonical || `${SITE_URL}/`);
  setMeta("name", "twitter:image", `${SITE_URL}/icon-logo.png`);
  document.getElementById("sphome-schema")?.remove();
  const data = structuredData(meta);
  if (data) {
    const script = document.createElement("script");
    script.id = "sphome-schema";
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  }
}

export { applySeo };
export default { applySeo };
